import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import BootstrapModal from "designs/v1/pages/ModifyKyc/components/BootstrapModal";
import { getApiUrl } from "utils";
import {
  getBankReviewApi,
  submitBankReviewApi,
  bankRequestForEsign,
} from "designs/v1/pages/ModifyKyc/services";

const BankModificationReview = ({
  stageScreen,
  setStageScreen,
  setStep,
  isLoading,
  setIsLoading,
}) => {
  const history = useHistory();
  const [reviewData, setReviewData] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("BankRequestNumber"),
      bank_modification_type: localStorage.getItem("BankRequestType"),
    };
    const loadReview = async () => {
      try {
        const resp = await getBankReviewApi(payload);
        setReviewData(resp.data?.data);
        console.log("resp", resp);
      } catch (error) {
        console.log("err", error);
      }
    };
    loadReview();
    return () => {
      // localStorage.removeItem("BankRequestNumber");
    };
  }, []);

  const handleShowHideModal = () => {
    setShowModal((bool) => !bool);
  };

  const handleSubmit = async () => {
    const payload = {
      request_type: stageScreen,
      doc_name: localStorage.getItem("BankRequestNumber"),
    };
    console.log("payload", payload);
    setShowModal(false);
    setIsLoading(true);
    try {
      const resp = await submitBankReviewApi(payload);
      console.log("resp", resp);
      try {
        const esignResp = await bankRequestForEsign(payload);
        setIsLoading(false);
        if (esignResp.data.message?.status_code !== 200) {
          return toast.error(
            resp.esignResp?.message?.message ||
              "Internal server error!"
          );
        }
        if (resp.data.message?.status_code !== 200) {
          return toast.error(
            resp.data?.message?.message ||
              "Internal server error!"
          );
        }
        toast.success(resp.data?.message?.message);
        setStep("BankModificationESignature");
      } catch (error) {
        const { data } = error.response || {};
        toast.error(
          data.message?.message || "Internal server error!"
        );
        setIsLoading(false);
      }
    } catch (error) {
      console.log("err", error);
      setIsLoading(false);
      const { data } = error.response;
      toast.error(
        data.message?.message || "Internal server error!"
      );
    }
  };

  return (
    <>
      <Title title="Review Details" />
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <div className="mb-2">
              {reviewData && (
                <div>
                  <div className="row my-4">
                    <div className="row">
                      <h6 className="col-sm text-bold m-0">Request Type</h6>
                      <div className="col-sm">{reviewData?.request_type}</div>
                    </div>
                  </div>
                  <div className="row my-4">
                    <h6 className="text-bold m-0">User Details</h6>
                    <div className="row mt-1">
                      <div className="col-sm">Full Name</div>
                      <div className="col-sm">
                        {reviewData.current_user_details?.full_name}
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-sm">Mobile Number</div>
                      <div className="col-sm">
                        {reviewData.current_user_details?.mobile?.slice(2)}
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-sm">Email Address</div>
                      <div className="col-sm">
                        {reviewData.current_user_details?.email}
                      </div>
                    </div>
                    <div className="row mt-1">
                      <div className="col-sm">PAN Number</div>
                      <div className="col-sm">
                        {reviewData.current_user_details?.pan_number}
                      </div>
                    </div>
                  </div>
                  {/* <div className="row my-4">
                    <div className="row">
                      <h6 className="col-sm text-bold m-0">Reason Details</h6>
                      <div className="col-sm">
                        {reviewData.reason_details?.user_input_reason}
                      </div>
                    </div>
                  </div> */}
                  <div className="row my-4">
                    <div className="row">
                      <h6 className="col-sm text-bold m-0">Request Number</h6>
                      <div className="col-sm">
                        {reviewData.rekyc_bank_modi_request_name}
                      </div>
                    </div>
                  </div>
                  <div className="row my-4">
                    <h6 className="text-bold m-0">New Bank Details</h6>
                    {!reviewData?.modification_details?.length ? (
                      <>
                        <div className="row my-1">
                          <div className="col-sm">Name</div>
                          <div className="col-sm">
                            {reviewData.modification_details?.registered_name}
                          </div>
                        </div>
                        <div className="row my-1">
                          <div className="col-sm">Account Type</div>
                          <div className="col-sm">
                            {reviewData.modification_details?.account_type}
                          </div>
                        </div>
                        <div className="row my-1">
                          <div className="col-sm">Account Number</div>
                          <div className="col-sm">
                            {
                              reviewData.modification_details
                                ?.verified_account_number
                            }
                          </div>
                        </div>
                        <div className="row my-1">
                          <div className="col-sm">Bank Name</div>
                          <div className="col-sm">
                            {
                              reviewData.modification_details
                                ?.verified_bank_name
                            }
                          </div>
                        </div>
                        <div className="row my-1">
                          <div className="col-sm">Branch Name</div>
                          <div className="col-sm">
                            {reviewData.modification_details?.verified_branch}
                          </div>
                        </div>
                        <div className="row my-1">
                          <div className="col-sm">IFSC code</div>
                          <div className="col-sm">
                            {reviewData.modification_details?.verified_ifsc}
                          </div>
                        </div>
                        <div className="row my-1">
                          <div className="col-sm">Primary Bank</div>
                          <div className="col-sm">
                            {reviewData.modification_details
                              ?.is_primary_bank_account === 1
                              ? "Yes"
                              : "No"}
                          </div>
                        </div>
                        {reviewData.modification_details
                          ?.upload_cancelled_cheque && (
                          <div className="row my-1">
                            <div className="col-sm">Cheque Image</div>
                            <div className="col-sm">
                              <img
                                src={`${getApiUrl()}/${
                                  reviewData.modification_details
                                    ?.upload_cancelled_cheque
                                }`}
                                width="200"
                                alt=""
                              />
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <>
                        {reviewData?.modification_details?.length > 0 && (
                          <div className="row mt-2">
                            <table className="table mx-2">
                              <thead>
                                <tr>
                                  <th scope="col">Name</th>
                                  <th scope="col">Account Type</th>
                                  <th scope="col">Account Number</th>
                                  <th scope="col">Bank Name</th>
                                  <th scope="col">Branch</th>
                                  <th scope="col">IFSC Code</th>
                                  {/* <th scope="col">MICR Code</th> */}
                                  <th scope="col">Primary Bank</th>
                                </tr>
                              </thead>
                              <tbody>
                                {reviewData.modification_details
                                  .filter(
                                    (item) => item.verified_bank_account === 1
                                  )
                                  .map((item, idx) => {
                                    return (
                                      <tr key={idx}>
                                        <td>{item.registered_name}</td>
                                        <td>{item.account_type || "-"}</td>
                                        <td>{item.verified_account_number}</td>
                                        <td>{item.verified_bank_name}</td>
                                        <td>{item.verified_branch}</td>
                                        <td>{item.verified_ifsc}</td>
                                        {/* <td>{item.verified_micr_code || "-"}</td> */}
                                        <td>
                                          {item.is_primary_bank_account === 1
                                            ? "Yes"
                                            : "No"}
                                        </td>
                                      </tr>
                                    );
                                  })}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                  <div className="row my-4">
                    <Button
                      title="Submit"
                      type="button"
                      handleClick={handleShowHideModal}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <BootstrapModal
        show={showModal}
        title="Modify Bank"
        content={"Are you sure you want to modify this Bank?"}
        loading={isLoading}
        handleClose={handleShowHideModal}
        handleSubmit={handleSubmit}
      />
    </>
  );
};

export default BankModificationReview;
